import React from 'react';

function About() {
  const aboutCards = [
    {
      title: 'Expert Team',
      points: [
        'Years of installation experience',
        'Trained safety professionals',
        'Perfect alignment finish',
        'Zero damage at site',
      ],
    },
    {
      title: 'Premium Net Quality',
      points: [
        'UV-stabilized strong nylon',
        'Weather & heat resistant',
        'Long-life durability',
        'Neat and sleek appearance',
      ],
    },
    {
      title: 'Safe for Birds',
      points: [
        'No harm, no trapping',
        'Eco-friendly safety',
        'Stops nesting & droppings',
        'Fully humane control',
      ],
    },
    {
      title: 'Fast Installation',
      points: [
        'Same-day visit available',
        'Quick and clean setup',
        'Reliable skilled workforce',
        'Minimal disruption',
      ],
    },
    {
      title: 'Wide Pune Coverage',
      points: [
        'Pune & PCMC areas',
        'Societies to industries',
        'Balcony to warehouses',
        'Anywhere you need',
      ],
    },
    {
      title: 'Value for Money',
      points: [
        'Affordable pricing',
        'Transparent estimate',
        'No hidden charges',
        'High service value',
      ],
    },
    {
      title: 'Strong Protection',
      points: [
        'Keeps pigeons away',
        'Prevents wall staining',
        'Stops balcony litter',
        'Keeps area hygienic',
      ],
    },
    {
      title: 'Aesthetic Look',
      points: [
        'Matches building color',
        'Neat joint finish',
        'Slim rope structure',
        'Visually clean design',
      ],
    },
    {
      title: 'Quality Hardware',
      points: [
        'Stainless-steel hooks',
        'Marine-grade fixtures',
        'Rust-proof materials',
        'Secure installation',
      ],
    },
    {
      title: 'Professional Support',
      points: [
        'Friendly inspection team',
        'Post-service assistance',
        'Customer-first approach',
        'Trusted by 1000+ homes',
      ],
    },
    {
      title: 'Indoor & Outdoor Fit',
      points: [
        'Balconies & windows',
        'Ducts & terraces',
        'Industrial sheds',
        'Glass fronts too',
      ],
    },
    {
      title: 'Long-Term Results',
      points: [
        'Maintenance-free setup',
        'Weather-tolerant build',
        'Strong knot strength',
        'Designed for daily use',
      ],
    },
  ];

  return (
    <>
      <section id='about' className='py-2 px-5'>
        <div className='container'>
          <div className='row justify-content-center' data-aos='fade-down'>
            <div className='col-12 text-center mb-4'>
              <h2 className='fw-bold text-dark' style={{ fontSize: '2rem' }}>
                About Our Solutions
              </h2>
              <p
                style={{
                  fontSize: '1rem',
                  maxWidth: '800px',
                  margin: '0 auto',
                  color: '#555',
                }}
              >
                Smart, safe, and long-lasting protection from birds — engineered
                for homes, societies, and commercial spaces across Pune.
              </p>
            </div>

            {/* Feature Grid */}
            <div className='row g-4 mt-2'>
              {aboutCards.map((card, idx) => (
                <div
                  className='col-12 col-md-6 col-lg-3'
                  key={idx}
                  data-aos='zoom-in'
                  data-aos-delay={idx * 50}
                >
                  <div className='card h-100 shadow-sm border-0 p-3 rounded-3 about-card '>
                    <h6
                      className='fw-semibold mb-2 px-2'
                      style={{ color: '#222', fontSize: '1rem' }}
                    >
                      {card.title}
                    </h6>
                    <ul
                      className='ps-3 mb-0'
                      style={{ color: '#333', fontSize: '0.9rem' }}
                    >
                      {card.points.map((point, i) => (
                        <li key={i} className='mb-1 '>
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>

            <div className='text-center mt-5'>
              <hr className='w-50 mx-auto' />
            </div>
          </div>
        </div>
      </section>

      <style>{`
        #about h2 {
          font-weight: 700;
        }

        .about-card {
          transition: all .25s ease-in-out;
          background: #fff;
        }

        .about-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 8px 22px rgba(0,0,0,0.16);
        }
      `}</style>
    </>
  );
}

export default About;
